/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTimeEntryRequest
 */
export interface CreateTimeEntryRequest {
    /**
     * 
     * @type {Date}
     * @memberof CreateTimeEntryRequest
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof CreateTimeEntryRequest
     */
    timeWorked: number;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryRequest
     */
    workPackageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryRequest
     */
    labourCodeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryRequest
     */
    billingRoleId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryRequest
     */
    billingStatus: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateTimeEntryRequest
     */
    statusId?: string | null;
}

/**
 * Check if a given object implements the CreateTimeEntryRequest interface.
 */
export function instanceOfCreateTimeEntryRequest(value: object): value is CreateTimeEntryRequest {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('timeWorked' in value) || value['timeWorked'] === undefined) return false;
    if (!('workPackageId' in value) || value['workPackageId'] === undefined) return false;
    if (!('labourCodeId' in value) || value['labourCodeId'] === undefined) return false;
    if (!('billingRoleId' in value) || value['billingRoleId'] === undefined) return false;
    if (!('billingStatus' in value) || value['billingStatus'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function CreateTimeEntryRequestFromJSON(json: any): CreateTimeEntryRequest {
    return CreateTimeEntryRequestFromJSONTyped(json, false);
}

export function CreateTimeEntryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTimeEntryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'timeWorked': json['timeWorked'],
        'workPackageId': json['workPackageId'],
        'labourCodeId': json['labourCodeId'],
        'billingRoleId': json['billingRoleId'],
        'billingStatus': json['billingStatus'],
        'description': json['description'],
        'statusId': json['statusId'] == null ? undefined : json['statusId'],
    };
}

export function CreateTimeEntryRequestToJSON(value?: CreateTimeEntryRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'date': ((value['date']).toISOString().substring(0,10)),
        'timeWorked': value['timeWorked'],
        'workPackageId': value['workPackageId'],
        'labourCodeId': value['labourCodeId'],
        'billingRoleId': value['billingRoleId'],
        'billingStatus': value['billingStatus'],
        'description': value['description'],
        'statusId': value['statusId'],
    };
}

